<template>
  <div>
    <input
      type="hidden"
      name="main_staff_id"
      :value="model"
    >
    <select
      v-model="model"
      :disabled="!admin"
      class="form-control"
      required
    >
      <option
        v-if="staffAvailable.length == 0"
        :value="null"
      >
        Please assign staff first
      </option>
      <option
        v-for="(s, i) in staffAvailable"
        :key="i"
        :value="s.staff_id"
      >
        {{ s.name }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    staffAssigned: {
      type: [Array],
      required: false,
      default() {
        return [];
      },
    },
    staffMainId: {
      type: [Number, String],
      required: false,
      default() {
        return null;
      },
    },
    self: {
      type: [Object],
      required: false,
      default: () => null,
    },
    admin: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    newProject: {
      type: Boolean,
      required: false,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {
    staffAvailable() {
      return this.$store.state.project.selectedProjectStaff || [];
    },
  },
  watch: {
    staffAvailable() {
      if (this.model != null && this.staffAvailable.filter((e) => e.staff_id === this.model).length === 0) {
        this.model = null;
      }

      if (this.model == null && this.staffAvailable.length > 0) {
          const staff = this.staffAvailable.find(staff => Number(staff.user_id) === Number(this.self.id))
          if(staff !== undefined) {
              this.model = staff.staff_id;
          }
      }
    },
  },
  mounted() {
    if (this.staffMainId) {
      this.model = this.staffMainId;
    } else if (this.self) {
      this.model = this.self.id;
    }
  },
};
</script>
